/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useState } from 'react'

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Spinner,
  useClipboard,
  Button
} from '@chakra-ui/react'

const ModalAuth0AccessToken = ({ getAccessToken }) => {
  const { onCopy, value, setValue, hasCopied } = useClipboard('')
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [auth0Token, setAuth0Token] = useState('')
  const [hasError, setHasError] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const currentOnOpen = async () => {
    let token
    onOpen()

    try {
      token = await getAccessToken()
      setAuth0Token(token)
      setValue(token)
    } catch (error) {
      setHasError(true)
    }

    setIsLoading(false)
  }

  return (
    <>
      <Button onClick={currentOnOpen}>Show Auth0 Access Token</Button>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Auth0 Access Token</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            { isLoading
              ? <Spinner />
              : hasError
                ? <div>Failed to fetch token</div>
                : auth0Token
            }
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme='gray'
              mr={3}
              onClick={onClose}
            >
              Close
            </Button>
            { value &&
              <Button
                onClick={onCopy}
              >
                { hasCopied ? 'Copied!' : 'Copy' }
              </Button>
            }
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ModalAuth0AccessToken
